




























import Vue from "vue";

interface IState {
  body: HTMLElement | null;
}

export default Vue.extend({
  name: "Step",
  props: {
    tip: { type: Object, default: () => ({}) },
    next: { type: Function, default: () => null },
    close: { type: Function, default: () => null },
    rect: { type: Object, default: () => ({}) },
  },
  data(): IState {
    return {
      body: document.querySelector(".main"),
    };
  },
  computed: {
    width(): number {
      if (this.body)
        return this.body.clientWidth - this.rect.lft - this.rect.rgt;
      else return 0;
    },
    top(): number {
      if (this.body) return this.body.clientHeight - this.rect.bot;
      else return 0;
    },
  },
});
